import { render, staticRenderFns } from "./ExchangeLog.vue?vue&type=template&id=0c29a508&scoped=true&"
import script from "./ExchangeLog.vue?vue&type=script&lang=js&"
export * from "./ExchangeLog.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeLog.vue?vue&type=style&index=0&id=0c29a508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c29a508",
  null
  
)

export default component.exports